import React from 'react'
import {
  IconPDLSparkle,
  IconContentConverter,
  IconVideoQuizTest,
  IconSnapQuizTest,
  IconSmartBuildTest,
  IconGoogleForm,
} from '@edulastic/icons'

// Content Converter imports are aiGenerated + aiDocExtracted
export const getTestType = ({
  aiGenerated,
  aiDocExtracted,
  isDocBased,
  videoUrl,
  isDynamicTest,
  importData,
}) => {
  if (importData?.googleForm) {
    return {
      key: 'google-form',
      icon: <IconGoogleForm width={14} height={18} />,
      label: 'Imported from Google Forms',
    }
  }
  if (aiGenerated) {
    return aiDocExtracted
      ? {
          key: 'content-converter',
          icon: <IconContentConverter width={22} height={22} />,
          label: 'Generated via Content Converter',
        }
      : {
          key: 'ai',
          icon: <IconPDLSparkle width={22} height={22} />,
          label: 'AI-Assisted',
        }
  }
  if (isDocBased) {
    return videoUrl
      ? {
          key: 'video',
          icon: <IconVideoQuizTest hideBackground width={24} height={17} />,
          label: 'Video Quiz',
        }
      : {
          key: 'pdf',
          icon: <IconSnapQuizTest hideBackground width={15} height={18} />,
          label: 'PDF Test',
        }
  }
  if (isDynamicTest) {
    return {
      key: 'dynamic',
      icon: <IconSmartBuildTest hideBackground width={16} height={18} />,
      label:
        'SmartBuild Test. Every student might get different items in assignment',
    }
  }
  return null
}
